<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main" *ngIf="isLoaded">
    <h2 id="title-agreements">
        {{ 'documents.title' | signatureAction: currentSignature?.action | translate:{NB_DOCUMENTS: signatures.length} }}
        <small> <span *ngIf="signerName()">-
            {{signerName()}}</span>
        </small>
    </h2>

    <section class="infoBox" *ngIf="signatures">
        <p id="nb-documents" *ngIf="containsTrueSignatures">
            {{ 'documents.infoBox' | signatureAction: 'SIGNATURE' | translate:{NB_DOCUMENTS: trueSignatures.length} }}
            <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
        </p>
        <ul *ngIf="containsTrueSignatures"
            [ngClass]="{'noBullet' : trueSignatures.length == 1}">
            <li *ngFor="let signature of trueSignatures; let i = index" id="doc-to-process-{{i}}">
                {{signature.documentDto?.documentName}} : <strong
                    *ngIf="signatureIsDone(signature)">{{
                'documents.document.agreed' | signatureAction: 'SIGNATURE'
                    | translate }}</strong> <strong
                    *ngIf="!signatureIsDone(signature)">{{
                'documents.document.not.agreed' | signatureAction:
                    'SIGNATURE' | translate }}</strong>
            </li>
        </ul>
        <br/>
        <p id="nb-documents-approval" *ngIf="containsApprovals">
            {{ 'documents.infoBox' | signatureAction: 'APPROVAL' | translate:{NB_DOCUMENTS: approvals.length} }}
            <app-wl-electronic-signature-purpose class="right" *ngIf="!containsTrueSignatures"></app-wl-electronic-signature-purpose>
        </p>
        <ul *ngIf="containsApprovals"
            [ngClass]="{'noBullet' : approvals.length == 1}">
            <li *ngFor="let signature of approvals; let i = index" id="doc-to-validate-{{i}}">
                {{signature.documentDto?.documentName}} : <strong
                    *ngIf="signatureIsDone(signature)">{{
                'documents.document.agreed' | signatureAction: 'APPROVAL'
                    | translate }}</strong> <strong
                    *ngIf="!signatureIsDone(signature)">{{
                'documents.document.not.agreed' | signatureAction:
                    'APPROVAL' | translate }}</strong>
            </li>
        </ul>
    </section>

    <section>
        <pdf-viewer *ngIf="currentSignature && !isFinalAgreement()" [downloadUrl]="getDownloadUrl()" [pdfInfoUrl]="getPdfInfoUrl()"
                    [token]="getToken()"
                    [pdfName]="currentSignature.documentDto?.documentName"></pdf-viewer>

        <p class="error-form content documentComplete" id="error-pdf-complete-reading" *ngIf="controlDocumentCompleteReading && !documentFullyRead">
            {{ "documents.completeReading" | translate }}
        </p>
        <form id="form-consents" [formGroup]="formConsentsValidation" name="form.consents"
              novalidate>
            <div *ngIf="consents">
                <p>
                    <small id="mandatory-consents">{{ 'documents.consents.mandatory' | translate }}
                    </small>
                </p>
                <fieldset class="k-check" *ngFor="let consent of consents">
                    <legend id="consent-title">{{consent.title}}</legend>
                    <ul>
                        <li *ngFor="let consentText of consent.consentTextDtoList">

                            <input
                                    type="checkbox"
                                    [formControlName]="'consent-'+consent.rank+'_text-'+consentText.status.rank"
                                    [id]="'consent-'+consent.rank+'_text-'+consentText.status.rank"
                                    [required]="consentText.mandatory"
                                    [(ngModel)]="consentText.status.ticked"
                                    [checked]="consentText.status.ticked"
                                    (change)="formReset()"
                                    [disabled]="alreadyConsented || (controlDocumentCompleteReading && !documentFullyRead)"/>
                            <label [for]="'consent-'+consent.rank+'_text-'+consentText.status.rank">
                                <span [id]="'label-consent-'+consent.rank+'_text-'+consentText.status.rank" [innerHTML]="consentText.text"></span>
                            </label>
                        </li>
                    </ul>
                </fieldset>
            </div>
        </form>
    </section>

    <section id="signature-error" *ngIf="signatureOnError">
        <p class="error-form">
            {{ signatureOnErrorText | translate }}</p>
    </section>

    <wl-certificate-approval *ngIf="isCertificateApprovalRequired" [multipledocuments]="areMultipleDocuments"
                             [(certificateValidation)]="certificateValidation"></wl-certificate-approval>
    <section *ngIf="smartphone">
        <h3>{{ 'documents.send.title' | signatureAction:
            currentSignature?.action | translate }}</h3>
        <form id="form-smartphone" class="content" novalidate
              name="form.smartphone" autocomplete="off">
            <!--            <p>-->
            <span class="code" id="smartphone-code-info">{{ 'documents.smartphone.code' | translate}}</span>
            <br/><br/>

            <div class="divBtnLeft">
                <button class="k-button"
                        *ngIf="sendSms" (click)="sendSms()" id="send-smartphone-sms-button"
                        [disabled]="linkSMSAlreadySent">{{'documents.smartphone.code.sms' | translate : {phone: currentSigner.phone} }}</button>
                <button class="k-button"
                        *ngIf="sendEmail" (click)="sendEmail()" id="send-smartphone-mail-button"
                        [disabled]="linkEmailAlreadySent"> {{'documents.smartphone.code.mail' | translate : {email: currentSigner.email} }}</button>
            </div>
            <div class="divBtnRight" *ngIf="smartphoneAgreementSent">
                <span id="jnlpSpinner"><img alt="waiting..." class="divSpinner" src="../../../images/loading.svg"/></span>
            </div>
            <!--            </p>-->
            <br/>
            <p class="noticeSendMsg" *ngIf="linkSMSAlreadySent">{{'documents.smartphoneSMS.already.sent' | translate:{phone: currentSigner.phone}
                }}</p>
            <p class="noticeSendMsg"
               *ngIf="linkEmailAlreadySent">{{'documents.smartphoneEmail.already.sent' | translate:{email: currentSigner.email} }}</p>
        </form>
    </section>

    <section *ngIf="otp">
        <h3 id="otp-title">{{ 'documents.send.title' | signatureAction:
            currentSignature?.action | translate }}</h3>
        <form id="form-otp" class="content" (submit)="submit()" novalidate [formGroup]="formAgreementsValidation"
              name="form.agreements" autocomplete="off">

            <p class="error-form" id="otp-required-error-msg"
               *ngIf="submitted && formAgreementsValidation.get('codeOtp')?.errors?.['required']">
                {{ "agreements.form.codeOtp.error.required" | translate }}</p>
            <p class="error-form" id="otp-pattern-error-msg"
               *ngIf="submitted && formAgreementsValidation.get('codeOtp')?.errors?.['pattern']">
                {{ "agreements.form.codeOtp.error.pattern" | translate }}</p>
            <p class="error-form" id="otp-error-msg">{{ otpErrorMsg | translate }}</p>
            <p *ngIf="!otpSent">
                <span id="otp-code-info" class="code">{{ 'documents.otp.code' | translate }}</span>
                <br/><br/>
                <button type="button" class="k-button" id="send-sms-button"
                        *ngIf="sendSms" (click)="sendSms()"> {{'documents.otp.code.sms' | translate : {phone: currentSigner.phone} }}</button>

                <button type="button" class="k-button" id="send-email-button"
                        *ngIf="sendEmail" (click)="sendEmail()">{{'documents.otp.code.mail' | translate : {email: currentSigner.email} }}
                </button>
                <br/><br/> <br/>
                <span id="otp-already-sent" *ngIf="!otpSent" class="link"
                      (click)="isAlreadySent()">{{'documents.otp.already.sent' | translate }}</span>
            </p>
            <p *ngIf="otpSent">
                <label id="enter-otp-label">{{ 'documents.otp.form.otp.label' |
                    translate }}</label> <input id="codeOtp" name="codeOtp"
                                                [(ngModel)]="form.otpValue"
                                                [pattern]="otpPattern"
                                                *ngIf="otpPattern"
                                                required
                                                type="text" formControlName="codeOtp"/>
                <br/>
                <span class="lost-code">{{'documents.otp.lost.code' | translate }}</span>
                <br/><br/>
                <button type="button" class="k-button k-button-primary" id="send-sms-button-2"
                        *ngIf="sendSms" (click)="sendSms()">{{'documents.otp.code.sms' | translate :{phone: currentSigner.phone} }}</button>
                <button type="button" class="k-button k-button-primary" id="send-email-button-2"
                        *ngIf="sendEmail" (click)="sendEmail()">{{'documents.otp.code.mail' | translate :{email: currentSigner.email} }}</button>
                <br/><br/> <br/>
                <span id="otp-sent-message">{{otpMsg | translate :{phone: currentSigner.phone, email: currentSigner.email} }}</span>
            </p>

            <p class="k-buttons-bar" *ngIf="!isCertificateApprovalRequired">
                <input type="button" *ngIf="onHoldAvailability && !onHoldLimitReached" value="{{ 'confirmCancellation.hold' | translate }}"
                       class="k-button k-button-primary"
                       (click)="hold()"/>
                <input type="submit" id="sign-button"
                       value="{{ signatureButtonText | signatureAction: currentSignature?.action | translate }}"
                       class="k-button ic-check submitConsent" [disabled]="isSubmitButtonDisabled() || !otpSent"
                       [attr.uib-tooltip]="'tooltip.agreements.sign' | translate"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled() || !otpSent"
                />

            </p>
            <p class="k-buttons-bar" *ngIf="isCertificateApprovalRequired">
                <input type="button" *ngIf="onHoldAvailability && !onHoldLimitReached" value="{{ 'confirmCancellation.hold' | translate }}"
                       class="k-button k-button-primary"
                       (click)="hold()"/>
                <input type="submit" id="approve-button"
                       value="{{ 'certificate.approval.button.approval' | translate }}"
                       class="k-button ic-check submitConsent"
                       [disabled]="isSubmitButtonDisabled() || !otpSent"
                       [attr.uib-tooltip]="'tooltip.agreements.sign' | translate"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled() || !otpSent"/>
            </p>
        </form>
    </section>

    <section *ngIf="click">
        <form id="form_click" (submit)="submit()" novalidate name="form.click"
              autocomplete="off">
            <p class="k-buttons-bar">
                <input id="hold-button" type="button" *ngIf="onHoldAvailability && !onHoldLimitReached"
                       value="{{ 'confirmCancellation.hold' | translate }}"
                       class="k-button k-button-primary"
                       (click)="hold()"/>
                <input type="submit" id="submit-button"
                       value="{{ signatureButtonText | signatureAction: currentSignature?.action | translate }}"
                       class="k-button ic-check submitConsent"
                       [disabled]=" isSubmitButtonDisabled()"
                       [attr.uib-tooltip]="'tooltip.agreements.sign' | translate"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled() "
                />
            </p>

        </form>
    </section>

    <section *ngIf="handsign">

        <form id="form_handsign" (submit)="submit()" novalidate
              name="form.handsign" autocomplete="off">
            <h3>{{ 'signature.title' | translate}}</h3>

            <br/>

            <p class="error-form" *ngIf="signaturePad && signaturePad.isEmpty() && submitted">{{
                "signature.form.error.required" | translate }}</p>

            <wl-hand-sign #signature [options]="handSignOptions"></wl-hand-sign>
            <br/>
            <p class="k-buttons-bar">
                <input type="button" *ngIf="onHoldAvailability && !onHoldLimitReached" value="{{ 'confirmCancellation.hold' | translate }}"
                       class="k-button k-button-primary"
                       (click)="hold()"/>
                <input type="submit" id="hand-sign-button"
                       value="{{ signatureButtonText | signatureAction: currentSignature?.action | translate }}"
                       class="k-button ic-check submitConsent"
                       [attr.uib-tooltip]="'tooltip.agreements.sign' | translate" [disabled]="signaturePad?.isEmpty() || isSubmitButtonDisabled()"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled()"
                />
            </p>
        </form>

    </section>

    <section *ngIf="tablet">

        <div *ngIf="displayTabletLink">
            <h4 id="consent-pad-title">{{ 'consent.tablet.continue' | translate}}</h4>
            <div id="consent-pad-wait">
                {{ 'consent.tablet.wait' | translate}} <a [href]="jnlpUrl">{{'consent.tablet.wait2' | translate}}</a>
            </div>
        </div>

        <form autocomplete="off" id="form_tablet" name="form.tablet" *ngIf="isCertificateApprovalRequired || containsMandatoryConsents"
              (submit)="submit()" novalidate>
            <p class="k-buttons-bar">
                <input class="k-button ic-check submitConsent" [attr.uib-tooltip]="'tooltip.agreements.sign' | translate"
                       id="submit-button-tablet"
                       [disabled]="isSubmitButtonDisabled()"
                       [attr.uib-tooltip-enable]="isSubmitButtonDisabled()"
                       type="submit"
                       value="{{ signatureButtonText + '.signature.tablet' | translate }}"/>
            </p>
        </form>

    </section>

    <section id="signature-error-2" *ngIf="signatureOnError">
        <p class="error-form">
            {{ signatureOnErrorText | translate }}</p>
    </section>

    <p class="back-link">
        <span id="cancel-link" (click)="confirmCancel()">{{ 'evidences.cancel' | translate }}</span> <span *ngIf="errorMsg">{{ errorMsg | translate
        }}</span>
    </p>

</main>
